import React, { useEffect, useRef, useState } from "react";
import { FaDollarSign, FaUser } from "react-icons/fa";
import axios from "axios";
import { app_url } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Error500 from "../../components/500/Error500";
import { MdOutlineSimCardDownload } from "react-icons/md";
import { DateRangePicker } from "react-date-range";
import { addDays, setSeconds, setHours, setMinutes } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { formatDate } from "../../formatDate/formatDate";
import PartnerDiscountsModal from "../../components/modals/PartnerDiscountsModal";
import { VscVmActive } from "react-icons/vsc";
import { FcExpired } from "react-icons/fc";
import TopBundlesTable from "../../components/tables/TopBundlesTable";
import PartnerLeadsales from "../../components/charts/PartnerLeadSales";
import { FaEdit } from "react-icons/fa";
import PartnerOrdersTable from "../../components/tables/PartnerOrdersTable";
import stripeLogo from "../../assets/images/stripe-logo.png";
import paypalLogo from "../../assets/images/paypal-logo.png";

const PartnerDetails = () => {
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [networkIssue, setNetworkIssue] = useState(false);
  const [partnerData, setPartnerData] = useState({});
  const [discountPlan, setDiscountPlan] = useState([]);
  const [socialMediaLinks, setSocialMediaLinks] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const datePickerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [esimsData, setEsimsData] = useState([]);
  const [updateDiscountPlan, setUpdateDiscountPlan] = useState([]);
  const [updatePricePlan, setUpdatePricePlan] = useState([]);
  // const [selectedDiscountPlanUpdate, setSelectedDiscountPlanUpdate] =
  //   useState(null);
  const [selectedPricePlanUpdate, setSelectedPricePlanUpdate] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [sendingEmailDomain, setSendingEmailDomain] = useState("");
  const [isSendingEmailDomainEditable, setIsSendingEmailDomainEditable] =
    useState(false);
  const [showAccountsModal, setShowAccountsModal] = useState(false);
  // New state for account form
  const [showAccountFormModal, setShowAccountFormModal] = useState(false);
  const [accountFormData, setAccountFormData] = useState({
    accountName: "",
    gateway: "",
    publishKey: "",
    clientSecret: "",
    secretKey: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [showUpdateAccountModal, setShowUpdateAccountModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [updateFormData, setUpdateFormData] = useState({
    accountName: "",
    publishableKey: "",
    secretKey: "",
  });
  const [updateFormErrors, setUpdateFormErrors] = useState({});
  const [formUpdateLoading, setFormUpdateLoading] = useState(false);
  const [activeLoading, setActiveLoading] = useState(false);
  const [createAccountLoading, setCreateAccountLoading] = useState(false);
  const [stripeDetails, setStripeDetails] = useState(null);
  const [stripeActionLoading, setStripeActionLoading] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);

  const handleError = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        navigate("/");
      } else if (error.response.status === 500) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
    } else {
      setNetworkIssue(true);
      toast.error("Network error. Please check your internet connection.");
      setError("Network error. Please check your internet connection.");
    }
  };

  const handleAccountClick = (account) => {
    setSelectedAccount(account);
    setUpdateFormData({
      accountName: account.account_name || "",
      publishableKey: "",
      secretKey: "",
    });
    setShowUpdateAccountModal(true);
  };

  const handleUpdateFormChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear errors when user starts typing
    if (updateFormErrors[name]) {
      setUpdateFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateUpdateForm = () => {
    const errors = {};

    if (!updateFormData.accountName.trim()) {
      errors.accountName = "Account name is required";
    }

    if (!updateFormData.publishableKey.trim()) {
      errors.publishableKey = "Publishable key is required";
    }

    if (!updateFormData.secretKey.trim()) {
      errors.secretKey = "Secret key is required";
    }

    setUpdateFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetUpdateForm = () => {
    setUpdateFormData({
      accountName: "",
      publishableKey: "",
      secretKey: "",
    });
    setUpdateFormErrors({});
    setSelectedAccount(null);
  };

  const handleAccountFormChange = (e) => {
    const { name, value } = e.target;
    setAccountFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear errors when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateAccountForm = () => {
    const errors = {};

    if (!accountFormData.accountName.trim()) {
      errors.accountName = "Account name is required";
    }

    if (!accountFormData.gateway) {
      errors.gateway = "Please select a gateway";
    }

    if (!accountFormData.publishKey.trim()) {
      errors.publishKey = "Publishable key is required";
    }

    if (
      accountFormData.gateway === "stripe" &&
      !accountFormData.clientSecret.trim()
    ) {
      errors.clientSecret = "Client secret is required for Stripe";
    }

    if (
      accountFormData.gateway === "paypal" &&
      !accountFormData.secretKey.trim()
    ) {
      errors.secretKey = "Secret key is required for PayPal";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetAccountForm = () => {
    setAccountFormData({
      accountName: "",
      gateway: "",
      publishKey: "",
      clientSecret: "",
      secretKey: "",
    });
    setFormErrors({});
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalShow = () => setShowModal(true);

  /* Date Range Picker */
  function getLastDayOfMonth(year, month) {
    const nextMonth = month + 1;
    const date = new Date(year, nextMonth, 0);
    return date.getDate();
  }

  const month = new Date().getMonth();
  const year = new Date().getFullYear();

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const getStartDateForInitialState = () => {
    const actualDate = addDays(new Date(), +1 - new Date().getDate());
    const adjustedStartDate = setSeconds(
      setMinutes(setHours(actualDate, 0), 0),
      0,
    );
    return adjustedStartDate;
  };

  const [state, setState] = useState([
    {
      startDate: getStartDateForInitialState(),
      endDate: new Date(year, month, getLastDayOfMonth(year, month)),
      key: "selection",
    },
  ]);

  //update dateFrom and dateTo based on state changes
  useEffect(() => {
    const formattedStartDate = formatDate(state[0].startDate);
    const formattedEndDate = formatDate(state[0].endDate);

    setdateFrom(formattedStartDate);
    setdateTo(formattedEndDate);
  }, [state]);
  /* Date Range Picker end*/

  // Date Picker outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* new Date Picker Data */
  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const adjustedEndDate = setSeconds(
      setMinutes(setHours(endDate, 23), 59),
      59,
    );
    const adjustedStartDate = setSeconds(
      setMinutes(setHours(startDate, 0), 0),
      0,
    );
    setState([
      {
        startDate: adjustedStartDate,
        endDate: adjustedEndDate,
        key: "selection",
      },
    ]);
  };

  const [dateFrom, setdateFrom] = useState(formatDate(state[0].startDate));
  const [dateTo, setdateTo] = useState(formatDate(state[0].endDate));

  useEffect(() => {
    axios
      .get(`${app_url}/api/partner/getDiscountPlans_for_partner`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setUpdateDiscountPlan(response?.data?.discountPlans);
      })
      .catch((error) => {
        handleError(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        `${app_url}/api/partner/fetchPartnerPlans?page=1&search=&numPerPage=50`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setUpdatePricePlan(response?.data?.result);
      })
      .catch((error) => {
        handleError(error);
      });
  }, []);

  const handlePasswordChange = (event) => {
    const value = event.target.value;

    const isValidPasswordFormat = /^[a-zA-Z0-9@_\[\].,]{8,}$/.test(value);

    if (!isValidPasswordFormat && value !== "") {
      setPasswordError(
        "Password must be alphanumeric, case-sensitive, no spaces, and may contain @, _, [, ] or ,",
      );
    } else {
      setPasswordError("");
    }
    setPassword(value);
    setInputValue(value);
  };

  // For discount plan
  const handleChangeDiscountPlan = (selectedPlan) => {
    // setSelectedDiscountPlanUpdate(selectedPlan);
    updateUserdetail("discount_plan", selectedPlan);
  };

  // For price plan
  const handleChangePricePlan = (selectedPlan) => {
    const isRemovingPlan = selectedPlan === "null";
    const planValue = isRemovingPlan ? null : selectedPlan;

    setSelectedPricePlanUpdate(planValue);
    updateUserdetail("price_plan", null, planValue);
  };

  const updateUserdetail = (slug, updatedPlan, updatedPricePlan) => {
    let data = {
      partner_id: partnerData?.id,
      slug: slug,
    };

    // console.log(data, "check data");

    if (slug === "discount_plan") {
      if (updatedPlan !== undefined && updatedPlan !== null) {
        data.dplan_id = Number(updatedPlan);
      }
    } else if (slug === "price_plan") {
      // Explicitly include partner_plan_id even when null
      data.partner_plan_id =
        updatedPricePlan !== undefined
          ? updatedPricePlan !== null
            ? Number(updatedPricePlan)
            : null
          : selectedPricePlanUpdate !== null
            ? Number(selectedPricePlanUpdate)
            : null;
    } else if (slug === "password") {
      if (password) {
        data.password = password;
      }
    } else if (slug === "sending_email_domain") {
      if (updatedPlan !== undefined && updatedPlan !== null) {
        data.sending_email_domain = updatedPlan.trim();
      }
    }

    // Only validate required fields for each case
    const shouldProceed =
      (slug === "discount_plan" && data.dplan_id !== undefined) ||
      (slug === "price_plan" && data.partner_plan_id !== undefined) ||
      (slug === "password" && data.password) ||
      (slug === "sending_email_domain" &&
        data.sending_email_domain !== undefined);

    if (shouldProceed) {
      axios
        .post(`${app_url}/api/partner/update_partner_values_by_id`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          toast.success(response.data.message);
          if (slug === "password") {
            setIsEditable(false);
            setInputValue("");
          }
          if (slug === "sending_email_domain") {
            setIsSendingEmailDomainEditable(false);
            setPartnerData((prev) => ({
              ...prev,
              sending_email_domain: data.sending_email_domain,
            }));
          }
          window.location.reload();
        })
        .catch((error) => {
          handleError(error);
        });
    } else {
      toast.error("Please provide valid data for the update");
    }
  };

  const getPartnerDetails = () => {
    window.scrollTo(0, 0);
    setLoading(true);
    axios
      .get(`${app_url}/api/partner/get_partner_by_id?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setDiscountPlan(res?.data?.dplan_slabs);
        const data = res?.data?.partner;
        setPartnerData(data);
        setStripeDetails(res?.data?.stripe_details);
        const links = data?.social_media_links;
        if (links) {
          try {
            setSocialMediaLinks(JSON.parse(links));
          } catch (error) {
            console.error("Error parsing social media links:", error);
            toast.error("Failed to parse social media links.");
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error);
      });
  };
  useEffect(() => {
    getPartnerDetails();
  }, []);

  useEffect(() => {
    setSendingEmailDomain(partnerData?.sending_email_domain || "");
  }, [partnerData?.sending_email_domain]);

  useEffect(() => {
    setIsLoading(true);
    if (partnerData?.id) {
      axios
        .get(
          `${app_url}/api/dashboard/getAdminPartnerDashboardDetails_byId?from=${dateFrom}&to=${dateTo}&id=${partnerData?.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          setEsimsData(res?.data?.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          handleError(error);
        });
    }
  }, [dateFrom, dateTo, partnerData?.id]);

  const handleToggleStripeStatus = (newStatus) => {
    setStripeActionLoading(true);
    axios
      .post(
        `${app_url}/api/partner/switchStripeConnectedAccountStatus`,
        {
          connect_account_id: stripeDetails?.current_account?.id,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      )
      .then((res) => {
        toast.success(res.data.message);
        getPartnerDetails();
      })
      .catch(handleError)
      .finally(() => setStripeActionLoading(false));
  };

  const handleRevokeStripeAccount = () => {
    setStripeActionLoading(true);
    axios
      .post(
        `${app_url}/api/partner/revokeConnectAccount`,
        { connect_account_id: stripeDetails?.current_account?.id },
        { headers: { Authorization: `Bearer ${token}` } },
      )
      .then((res) => {
        toast.success(res.data.message);
        setShowRevokeModal(false);
        window.location.reload();
      })
      .catch(handleError)
      .finally(() => setStripeActionLoading(false));
  };

  if (networkIssue) {
    return <Error500 message={error} />;
  }

  return (
    <section className="wrapper overflow-hidden">
      <div>
        <div className="d-flex justify-content-between align-items-center w-100 gap-2 flex-wrap">
          <div>
            <p className="heading">
              <i
                className="bi bi-arrow-left-circle-fill fs-3 me-3 my-auto pointer text-capitalize"
                onClick={() => window.history.back()}
              ></i>
              {partnerData?.agent_name}
            </p>
          </div>
          <p className="heading">eTijwaal Partner Center</p>
        </div>
        <div className="d-flex justify-content-between items-center">
          <div style={{ width: "13em" }}>
            <div class="shadow-sm d-flex align-items-center bg-white p-1 p-sm-2 rounded">
              <svg
                stroke="currentColor"
                fill="red"
                stroke-width="0"
                viewBox="0 0 24 24"
                className="d-inline-block align-middle text-danger me-2 custom-icon"
                style={{ width: "25px", height: "25px" }}
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path>
              </svg>
              {partnerData?.balance >= 10 ? (
                <h2 class="text-success fs-5 fw-semibold mb-0">
                  <span class=" fs-6 fw-light text-success">Balance:</span> $
                  {partnerData?.balance?.toFixed(3)}
                </h2>
              ) : (
                <h2 class="text-danger fs-5 fw-semibold mb-0">
                  <span class=" fs-6 fw-light text-danger">Balance:</span> $
                  {partnerData?.balance?.toFixed(3)}
                </h2>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        {/* Partner Details */}
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <ul className="list-group">
                <li className="list-group-item">
                  <strong>Username:</strong> {partnerData?.username}
                </li>
                <li className="list-group-item">
                  <strong>Email:</strong> {partnerData?.email}
                </li>
                <li className="list-group-item">
                  <strong>Mobile:</strong> {partnerData?.mobile}
                </li>
                <li className="list-group-item">
                  <strong>Company Name:</strong> {partnerData?.company_name}
                </li>
                <li className="list-group-item">
                  <strong>Address:</strong> {partnerData?.address}
                </li>
                <li className="list-group-item d-sm-flex justify-content-between align-items-center gap-3 flex-wrap">
                  <div className="d-flex gap-2 flex-wrap align-items-center">
                    <div className="d-flex align-items-center gap-2">
                      <strong>Discount Plan:</strong>
                      {partnerData?.dplan_name ? (
                        <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2 rounded-pill d-flex align-items-center gap-1">
                          {partnerData.dplan_name}
                          {partnerData?.dplan_description && (
                            <span className="text-muted ms-1">
                              ({partnerData.dplan_description})
                            </span>
                          )}
                        </span>
                      ) : (
                        <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-3 py-2 rounded-pill d-flex align-items-center gap-1">
                          <strong>Not Assigned</strong>
                        </span>
                      )}
                    </div>
                    <select
                      onChange={(e) => {
                        handleChangeDiscountPlan(e.target.value);
                      }}
                      className="border rounded px-2 py-1"
                      style={{ width: 190 }}
                    >
                      <option value="" disabled selected>
                        Update Discount Plan
                      </option>
                      {updateDiscountPlan?.map((plan) => (
                        <option key={plan?.id} value={plan?.id}>
                          {plan?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex justify-content-end mt-sm-0 mt-2">
                    <button
                      type="submit"
                      className="btn primary-btn"
                      onClick={handleModalShow}
                    >
                      Details
                    </button>
                  </div>
                </li>
                <li className="list-group-item d-sm-flex justify-content-between align-items-center gap-3">
                  <div className="d-flex gap-2 flex-wrap align-items-center">
                    <div>
                      <strong>Price Plan:</strong>{" "}
                      {partnerData?.price_plan_name ? (
                        <span className="badge bg-success fs-6">
                          {partnerData.price_plan_name}
                        </span>
                      ) : (
                        <span className="badge bg-danger fs-6">
                          Not Assigned
                        </span>
                      )}
                    </div>
                    <select
                      onChange={(e) => {
                        handleChangePricePlan(e.target.value);
                      }}
                      className="border rounded"
                      style={{ width: 190 }}
                    >
                      <option value="" disabled selected>
                        Update Price Plan
                      </option>
                      {/* <option value="null">Remove Price Plan</option> */}
                      {updatePricePlan?.map((plan) => (
                        <option key={plan?.id} value={plan?.id}>
                          {plan?.plan_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </li>
                <li className="list-group-item">
                  <strong>Partner Type:</strong>{" "}
                  <span className="text-capitalize">
                    {" "}
                    {partnerData?.partner_type?.replace(/_/g, " ")}
                  </span>
                </li>
                <li className="list-group-item">
                  <strong>Credit Limit:</strong> {partnerData?.credit_limit}
                </li>
                <li className="list-group-item">
                  <strong>Account Mode:</strong> {partnerData?.account_mode}
                </li>
                <li className="list-group-item">
                  <strong>Status:</strong>{" "}
                  {partnerData?.agent_status ? "Active" : "Inactive"}
                </li>
                <li className="list-group-item">
                  <strong>Joined:</strong>{" "}
                  {new Date(partnerData?.created_at).toLocaleDateString()}
                </li>
                <li className="d-flex gap-3 list-group-item flex-wrap">
                  <div className="">
                    <div className="d-flex align-items-center gap-2">
                      <strong>Password:</strong>
                      {/* Input Field */}
                      <div className="d-flex align-items-center position-relative">
                        <input
                          type="password"
                          value={password}
                          id="password"
                          onChange={handlePasswordChange}
                          disabled={!isEditable}
                          placeholder="******"
                          style={{
                            padding: "8px",
                            border: isEditable
                              ? "1px solid #000"
                              : "1px dashed #ccc",
                            backgroundColor: isEditable ? "#fff" : "#f9f9f9",
                            borderRadius: "4px",
                            outline: "none",
                          }}
                          required
                          maxLength={100}
                        />
                        {/* Edit Icon */}
                        {!isEditable && (
                          <button
                            type="button"
                            onClick={() => setIsEditable(true)}
                            className="btn primary-btn px-1 py-0 position-absolute "
                            style={{ right: "5px" }}
                          >
                            <FaEdit />
                          </button>
                        )}
                      </div>
                    </div>

                    {passwordError && (
                      <div
                        className="text-danger mt-1 "
                        style={{ maxWidth: "275px" }}
                      >
                        {passwordError}
                      </div>
                    )}
                  </div>

                  {/* Save Button */}
                  <div>
                    <button
                      type="button"
                      onClick={() => {
                        updateUserdetail("password");
                      }}
                      disabled={!isEditable || !inputValue}
                      style={{
                        padding: "8px 16px",
                        backgroundColor:
                          isEditable && inputValue && !passwordError
                            ? "#007bff"
                            : "#ccc",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor:
                          isEditable && inputValue && !passwordError
                            ? "pointer"
                            : "not-allowed",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="col-md-6">
          <div className="card shadow-sm" style={{ height: "30em" }}>
            <div>
              <div className="card-body">
                {socialMediaLinks?.length > 0 ? (
                  <>
                    <ul
                      className="list-group"
                      style={{ maxHeight: "28em", overflowY: "scroll" }}
                    >
                      <li className="list-group-item">
                        <strong>Customer Portal Url:</strong>{" "}
                        {partnerData?.cust_portal_url ? (
                          <a
                            href={partnerData?.cust_portal_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {partnerData?.cust_portal_url}
                          </a>
                        ) : (
                          "Not Provided"
                        )}
                      </li>
                      <li className="list-group-item d-flex gap-2 flex-wrap align-items-center">
                        <strong>Sending Email Domain:</strong>
                        <div className="d-flex align-items-center position-relative flex-grow-1">
                          <input
                            type="text"
                            value={sendingEmailDomain}
                            onChange={(e) =>
                              setSendingEmailDomain(e.target.value)
                            }
                            disabled={!isSendingEmailDomainEditable}
                            placeholder="example.com"
                            style={{
                              padding: "8px",
                              border: isSendingEmailDomainEditable
                                ? "1px solid #000"
                                : "1px dashed #ccc",
                              backgroundColor: isSendingEmailDomainEditable
                                ? "#fff"
                                : "#f9f9f9",
                              borderRadius: "4px",
                              outline: "none",
                              width: "100%",
                              maxWidth: "280px",
                            }}
                          />
                          {!isSendingEmailDomainEditable && (
                            <button
                              type="button"
                              onClick={() =>
                                setIsSendingEmailDomainEditable(true)
                              }
                              className="btn primary-btn px-1 py-0 position-absolute"
                              style={{ right: "5px" }}
                            >
                              <FaEdit />
                            </button>
                          )}
                        </div>
                        <button
                          type="button"
                          className="btn primary-btn"
                          onClick={() =>
                            updateUserdetail(
                              "sending_email_domain",
                              sendingEmailDomain,
                            )
                          }
                          disabled={!isSendingEmailDomainEditable}
                        >
                          Save
                        </button>
                      </li>
                      {socialMediaLinks.map((link, index) => (
                        <li
                          key={index}
                          className="list-group-item"
                          // style={{ padding: "13.45px 5px" }}
                        >
                          <strong>{link.name}:</strong>{" "}
                          {link.url ? (
                            <a
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.url}
                            </a>
                          ) : (
                            "Not Provided"
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p>No social media links available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-xl-flex px-3 py-3 justify-content-xl-between table-header-item mb-2">
        {/* new Date Picker Data */}
        <div
          className="dropdown d-flex flex-wrap sm:gap-3 gap-2"
          ref={datePickerRef}
        >
          <button
            className="btn btn-white border dropdown-toggle"
            type="button"
            onClick={toggleDatePicker}
          >
            Select Date
          </button>
          <div className="d-flex align-items-center gap-1 dropdown">
            <div className="order-date">
              <span className="pe-2">From:</span>
              <button
                type="button"
                disabled
                className="text-black btn btn-white border "
              >
                {dateFrom}
              </button>
            </div>
            <div className="order-date">
              <span className="pe-2">To:</span>
              <button
                type="button"
                disabled
                className="text-black btn btn-white border "
              >
                {dateTo}
              </button>
            </div>
          </div>
          {showDatePicker && (
            <ul
              className="dropdown-menu px-2 py-0 show"
              style={{ top: "46px", left: "-20px" }}
            >
              <li className="my-2 dropdown-item">
                <DateRangePicker
                  onChange={handleSelect}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={2}
                  ranges={state}
                  direction="horizontal"
                />
              </li>
            </ul>
          )}
        </div>
      </div>

      <div className="row ">
        <div className="col-lg-3 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Total Sales </p>
                <p className="heading m-0 text-black">
                  {esimsData?.eSim_data?.length > 0
                    ? esimsData?.eSim_data[0]?.total_sales?.toFixed(2)
                    : "0.00"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <FaDollarSign size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Total eSIM Sold</p>
                <p className="heading m-0 text-black">
                  {esimsData?.eSim_data?.length > 0
                    ? esimsData?.eSim_data[0]?.esim_sold
                    : "0"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <MdOutlineSimCardDownload size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Total Topup Sold</p>
                <p className="heading m-0 text-black">
                  {esimsData?.eSim_data?.length > 0
                    ? esimsData?.eSim_data[0]?.esim_top_sold
                    : "0"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <MdOutlineSimCardDownload size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Customer Registered</p>
                <p className="heading m-0 text-black">
                  {esimsData?.customer_registration_count?.length > 0
                    ? esimsData?.customer_registration_count[0]?.customers
                    : "0"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <FaUser size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="col-lg-4 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">active eSIMS </p>
                <p className="heading m-0 text-black">
                  {esimsData?.lineStatus?.length > 0
                    ? esimsData?.lineStatus[0]?.active_esims
                    : "0"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <VscVmActive size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Inactive eSIMS</p>
                <p className="heading m-0 text-black">
                  {esimsData?.lineStatus?.length > 0
                    ? esimsData?.lineStatus[0]?.inactive_esims
                    : "0"}
                </p>
              </div>

              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <i className="bi bi-sim-slash text-white fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-sm-6 my-3">
          <div className="card w-100">
            <div className="card-body pointer d-flex justify-content-between align-items-center">
              <div>
                <p className="fs-5">Expired Finished eSIMS</p>
                <p className="heading m-0 text-black">
                  {esimsData?.lineStatus?.length > 0
                    ? esimsData?.lineStatus[0]?.expired_finished_esims
                    : "0"}
                </p>
              </div>
              <div>
                <div className="back-secondary rounded-3 px-2 py-1">
                  <FcExpired size={30} fill="#fff" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TOP BUNDLES */}
      <div className="row my-5">
        <div className="col-md-8">
          <div className="card border-0 h-100 ">
            <div className="card-body">
              <h1 className="pb-4 heading border-bottom mb-4">
                Top Bundles Sold (eSIM/Topup)
              </h1>

              <div className="">
                <TopBundlesTable tabledata={esimsData} isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card border-0 h-100">
            <div className="card-body">
              <h2 className="pb-4 heading border-bottom mb-4">
                Country Metrics (eSIMS)
              </h2>
              {isLoading ? (
                <p className="fs-5">Loading...</p>
              ) : esimsData?.countryMetrics?.length === 0 ? (
                <p className="fs-5">No data found</p>
              ) : (
                <div
                  className="d-flex flex-column gap-3"
                  style={{
                    maxHeight: "41em",
                    overflow: "scroll",
                  }}
                >
                  {esimsData?.countryMetrics?.map((item, index) => {
                    const firstPackageCount =
                      esimsData?.countryMetrics[0]?.package_count || 0;
                    return (
                      <>
                        <div
                          className="align-items-center justify-content-between gap-2"
                          key={index}
                        >
                          <div
                            style={{ width: "100%", marginBottom: "5px" }}
                            className="fs-4 d-flex align-items-center"
                          >
                            {item?.flagImage_1 && (
                              <img
                                src={app_url + item?.flagImage_1}
                                alt=""
                                width={30}
                                className="me-2"
                              />
                            )}
                            <div className="d-flex justify-content-between w-100">
                              <span className="fs-5">
                                {item?.category.replace(/-/g, " ")}
                              </span>
                              <span className="fs-5 m-1">
                                {item?.package_count}
                              </span>
                            </div>
                          </div>
                          <div
                            className="progress"
                            style={{
                              width: "100%",
                            }}
                          >
                            <div
                              className="progress-bar progress-bar-striped progress-bar-animated"
                              role="progressbar"
                              aria-label="country metrices"
                              aria-valuenow={item?.package_count}
                              aria-valuemin="0"
                              aria-valuemax={firstPackageCount}
                              style={{
                                width: `${
                                  (item.package_count / firstPackageCount) * 100
                                }%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Partner Orders */}
      <div className="mb-5">
        <div className="card border-0">
          <div className="card-body overflow-hidden">
            <h1 className="pb-4 heading border-bottom mb-4">Partner Orders</h1>

            <div className="w-100 overflow-hidden">
              <PartnerOrdersTable partnerId={partnerData?.id} />
            </div>
          </div>
        </div>
      </div>

      <div className="row mx-0">
        <div className="col-md-8 w-100 mt-2 px-0">
          <div className="card border-0 h-100">
            <div className="card-body">
              <p className="heading">Summarize Sales</p>
              <hr />
              <PartnerLeadsales />
            </div>
          </div>
        </div>
      </div>

      {/* Stripe Details */}
      <div className="row mx-0 mt-4">
        <div className="col-12 px-0">
          <div className="card border-0">
            <div className="card-body">
              <div className="d-flex align-items-center gap-2 mb-2">
                <p className="heading mb-0">Stripe Connect Details</p>
              </div>
              <hr />

              <div
                className="d-flex align-items-start gap-2 rounded-3 p-3 mb-4"
                style={{
                  backgroundColor: "#eff6ff",
                  border: "1px solid #bfdbfe",
                }}
              >
                <i
                  className="bi bi-info-circle-fill mt-1"
                  style={{ color: "#3b82f6", flexShrink: 0 }}
                ></i>
                <p className="mb-0 small" style={{ color: "#1e40af" }}>
                  The following Stripe Connect account details are associated
                  with this partner's <strong>white-label website</strong>.
                  These credentials power the Stripe payment gateway on the
                  partner's storefront and manage their customers' saved card
                  information.
                </p>
              </div>

              {/* Current Account */}
              <h6
                className="fw-semibold mb-3 mt-4 text-secondary text-uppercase"
                style={{ fontSize: "0.8rem", letterSpacing: "0.05em" }}
              >
                Connected Account
              </h6>

              {stripeDetails?.current_account ? (
                <div className="card border rounded-3 mb-4">
                  <div className="card-body">
                    <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                      <div className="d-flex flex-column gap-2">
                        <div>
                          <span className="text-muted small">
                            Stripe Connect ID
                          </span>
                          <p className="mb-0 fw-semibold font-monospace">
                            {stripeDetails.current_account.stripe_connect_id}
                          </p>
                        </div>
                        <div className="d-flex gap-3 flex-wrap">
                          <div>
                            <span className="text-muted small">
                              Charges Enabled
                            </span>
                            <p className="mb-0">
                              {stripeDetails.current_account.charges_enabled ? (
                                <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill">
                                  Yes
                                </span>
                              ) : (
                                <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill">
                                  No
                                </span>
                              )}
                            </p>
                          </div>
                          <div>
                            <span className="text-muted small">Created</span>
                            <p className="mb-0 small">
                              {new Date(
                                stripeDetails.current_account.created_at,
                              ).toLocaleString()}
                            </p>
                          </div>
                          <div>
                            <span className="text-muted small">
                              Last Updated
                            </span>
                            <p className="mb-0 small">
                              {new Date(
                                stripeDetails.current_account.updated_at,
                              ).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="d-flex flex-column gap-2 md:align-items-end align-items-start">
                        {/* Active / Inactive Toggle */}
                        <div className="d-flex align-items-center gap-2">
                          <span className="small text-muted">
                            {stripeDetails.current_account.status === "active"
                              ? "Active"
                              : "Inactive"}
                          </span>
                          <div
                            className="form-check form-switch mt-0 me-2"
                            title={
                              stripeActionLoading
                                ? "Please wait..."
                                : "Toggle account status"
                            }
                          >
                            <input
                              className={`form-check-input active-unactive-pkg ${
                                stripeDetails.current_account.status ===
                                "inactive"
                                  ? "unactive-pkg"
                                  : "active-pkg"
                              }`}
                              type="checkbox"
                              role="switch"
                              id="stripeStatusToggle"
                              defaultChecked={
                                stripeDetails.current_account.status ===
                                "active"
                                  ? true
                                  : false
                              }
                              disabled={stripeActionLoading}
                              onChange={(e) =>
                                handleToggleStripeStatus(
                                  e.target.checked ? "active" : "inactive",
                                )
                              }
                              style={{
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                                cursor: stripeActionLoading
                                  ? "not-allowed"
                                  : "pointer",
                                width: "2.5em",
                                height: "1.3em",
                              }}
                            />
                          </div>
                        </div>

                        {/* Revoke Button */}
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => setShowRevokeModal(true)}
                          disabled={stripeActionLoading}
                        >
                          <i className="bi bi-slash-circle me-1"></i>
                          Revoke Account
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-muted fst-italic mb-4">
                  No active Stripe account found for white-label website.
                </p>
              )}

              {/* Revoked Accounts */}
              <h6
                className="fw-semibold mb-3 text-secondary text-uppercase"
                style={{ fontSize: "0.8rem", letterSpacing: "0.05em" }}
              >
                Revoked Accounts
              </h6>

              {stripeDetails?.revoked_accounts?.length > 0 ? (
                <div className="table-responsive" style={{ maxWidth: "900px" }}>
                  <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        {/* <th>#</th> */}
                        <th>Stripe Connect ID</th>
                        {/* <th>Charges Enabled</th> */}
                        <th>Revoked At</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stripeDetails.revoked_accounts.map((acc, idx) => (
                        <tr key={acc.id}>
                          {/* <td className="text-muted small">{idx + 1}</td> */}
                          <td className="font-monospace small">
                            {acc.stripe_connect_id}
                          </td>
                          {/* <td>
                            {acc.charges_enabled ? (
                              <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill">
                                Yes
                              </span>
                            ) : (
                              <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill">
                                No
                              </span>
                            )}
                          </td> */}
                          <td className="small text-muted">
                            {acc.revoked_at ? (
                              new Date(acc.revoked_at).toLocaleString()
                            ) : (
                              <span className="fst-italic">—</span>
                            )}
                          </td>
                          <td className="small text-muted">
                            {new Date(acc.created_at).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center gap-2 text-muted fst-italic p-3 rounded border bg-light"
                  style={{ maxWidth: "500px" }}
                >
                  <i className="bi bi-info-circle fs-5"></i>
                  <span>
                    No revoked Stripe accounts found for this partner.
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <PartnerDiscountsModal
          handleModalClose={handleModalClose}
          discountPlan={discountPlan}
        />
      )}

      {/* Revoke Stripe Account Confirmation Modal */}
      {showRevokeModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ zIndex: 1055 }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content border-0 shadow-lg">
                {/* Header */}
                <div className="modal-header border-0 pb-0">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#fff1f0",
                        flexShrink: 0,
                      }}
                    >
                      <i className="bi bi-exclamation-triangle-fill text-danger fs-5"></i>
                    </div>
                    <h5 className="modal-title fw-bold text-danger mb-0">
                      Revoke Stripe Account
                    </h5>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowRevokeModal(false)}
                    disabled={stripeActionLoading}
                  />
                </div>

                {/* Body */}
                <div className="modal-body pt-3">
                  <p className="text-dark mb-3">
                    Are you sure you want to revoke the Stripe connected account{" "}
                    <strong className="font-monospace">
                      {stripeDetails?.current_account?.stripe_connect_id}
                    </strong>
                    ?
                  </p>

                  {/* Warning Note */}
                  <div
                    className="rounded-3 p-3 d-flex gap-2"
                    style={{
                      backgroundColor: "#fff8e1",
                      border: "1px solid #ffe082",
                    }}
                  >
                    <i
                      className="bi bi-exclamation-circle-fill mt-1"
                      style={{ color: "#f59e0b", flexShrink: 0 }}
                    ></i>
                    <div>
                      <p
                        className="fw-semibold mb-1"
                        style={{ color: "#92400e" }}
                      >
                        Important — Please read before confirming:
                      </p>
                      <ul className="mb-0 ps-3" style={{ color: "#78350f" }}>
                        <li className="mb-1">
                          The{" "}
                          <strong>white-label Stripe payment gateway</strong>{" "}
                          will be immediately disabled for this partner's
                          storefront.
                        </li>
                        <li>
                          All <strong>customers' saved card details</strong>{" "}
                          associated with this account will be{" "}
                          <strong>permanently removed</strong> and cannot be
                          recovered.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 pt-0">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowRevokeModal(false)}
                    disabled={stripeActionLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleRevokeStripeAccount}
                    disabled={stripeActionLoading}
                  >
                    {stripeActionLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Revoking...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-slash-circle me-1"></i>
                        Yes, Revoke Account
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{ zIndex: 1054 }}
            onClick={() => !stripeActionLoading && setShowRevokeModal(false)}
          />
        </>
      )}
    </section>
  );
};

export default PartnerDetails;
